import { SonicImage } from "@discovery/components-luna/lib/components/atoms/image";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { Icon, Icons } from "../../atoms/icon";
import { Link } from "../../atoms/link";
import { PlaceholderImage } from "../../atoms/placeholder-image";
import { HeaderVariants, Tags, Typography } from "../../atoms/typography";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as styles from "./styles.css";
export const ShowOfTheMonth = ({ cards, title }) => {
    const showName = cards[0] && cards[0].name;
    const descriptionM = cards[0] && cards[0].descriptionM;
    const showRoute = cards[0] && cards[0].route;
    const image = cards[0] && cards[0].image;
    return (React.createElement("div", { className: styles.featuredBasicStandalone, id: "#showOfTheMonth" },
        React.createElement("div", { className: styles.rowWrapper },
            React.createElement("div", { className: styles.contentWrapper },
                React.createElement(Typography, { classNameM: M.of(styles.featuredTitle), variant: HeaderVariants.subHeadTwo, tag: Tags.span },
                    React.createElement(React.Fragment, null, title)),
                React.createElement("div", { className: styles.title }, showName),
                descriptionM && (React.createElement(RenderMaybe, null, M.map((description) => (React.createElement(Typography, { classNameM: M.of(styles.desc), variant: HeaderVariants.subHeadTwo, tag: Tags.span },
                    React.createElement(React.Fragment, null, description))), descriptionM))),
                showRoute && (React.createElement(Link, { href: showRoute },
                    React.createElement("div", { className: styles.iconWrapper },
                        React.createElement("div", { id: "#showplayButton" },
                            React.createElement(Icon, { className: styles.playButton, type: Icons.MastHeadPlayButton, color: "black" })),
                        React.createElement("span", { className: styles.watchnow }, "Watch Now"))))),
            React.createElement("div", { className: styles.imageWrapper },
                React.createElement("div", { className: styles.thumbnailImageContainer },
                    React.createElement("div", { className: styles.thumbnailImageWrapper },
                        React.createElement(PlaceholderImage, null),
                        image && (React.createElement(SonicImage, { image: image, imageSizes: {
                                default: [100, "vw"],
                                maxWidthMediaQueries: [
                                    [699, "px", 320, "px"],
                                    [1023, "px", 440, "px"],
                                    [1439, "px", 600, "px"],
                                    [2559, "px", 800, "px"],
                                ],
                            }, extraImageWidths: [320, 480, 700], className: styles.thumbnailImage, fallbackImageSize: { width: 900 }, alt: "" }))))))));
};

